import React from 'react';
import { DatePicker } from 'antd';
import DateFilter from './DateFilter';
import styles from './styles/date-filters.module.scss';
import { Label } from '@clockout-dev/design-elements';

const { RangePicker } = DatePicker;

function DateFilters({
    activeTimeFrame,
    dateRange,
    onTimeFrameChange,
    onDateRangeChange,
    label,
    id,
    labelSize,
    required,
    labelHeader,
    fontFamily,
    classNames,
    /** Extra antd RangePicker props (format, disabledDate, allowClear, ...). */
    rangePickerProps,
}) {
    const timeFrameOptions = [
        { label: 'All time', value: 'all' },
        // Named the way the active-filter chips name them ("Created date: Last 7
        // days"), so the control and the chip agree on what was picked.
        { label: 'Last 7 days', value: '7d' },
        { label: 'Last 30 days', value: '30d' },
        { label: 'Custom', value: 'custom' },
    ];

    // Derive visibility from the controlled prop so re-mounting the component
    // (e.g. inside a modal with destroyOnHidden) still reveals the picker when
    // the parent has `custom` selected.
    const showDatePicker = activeTimeFrame === 'custom';

    const handleTimeFrameChange = async (value) => {
        await onTimeFrameChange(value);
    };

    return (
        <Label
            label={label}
            htmlFor={id}
            size={labelSize}
            required={required}
            header={labelHeader}
            fontFamily={fontFamily}
            classNames={{label: classNames?.label, container: classNames?.labelContainer, header: classNames?.labelHeader}}
        >
            <div className={styles.dateFiltersContainer}>
                <div className={styles.dateFilters}>
                    {timeFrameOptions.map((data) => (
                        <DateFilter key={data.value} text={data.label} selected={activeTimeFrame === data.value} onClick={async () => await handleTimeFrameChange(data.value)} />
                    ))}
                </div>
                {showDatePicker ? (
                    <RangePicker {...(rangePickerProps || {})} value={dateRange} onChange={onDateRangeChange} />
                ) : null}
           </div>
        </Label>
    );
}

export default DateFilters;
